//Dependencies............................................
import React from 'react';
import {Layout, notification, Space} from 'antd';
import {Content} from "antd/lib/layout/layout";

//Components..............................................
import FirmwareBaseListView from "../../../Components/FirmwareManagerPageComp/Views/FirmwareBaseListView";
import JsonSchemaListView   from "../../../Components/FirmwareManagerPageComp/Views/JsonSchemaListView";
import GlobalLatestFirmwareView from '../../../Components/FirmwareManagerPageComp/Views/GlobalLatestFirmwareView';

const spaceStyle: React.CSSProperties = {
  marginLeft: 5,
  marginRight: 5,
  width: 500
};
const spaceCarViewStyle: React.CSSProperties = {
  marginLeft: 5,
  marginRight: 5
};

const FirmwareManagerView: React.FC = () =>{
  const [api, contextHolder] = notification.useNotification();

  return (
    <Layout className="layout" style={{height: "100vh"}}>
      {contextHolder}
      <Content style={{margin: '24px 16px 0', overflow: 'initial', height: "100vh", boxSizing: "border-box"}}>
        <Space orientation="vertical" size={16} style={spaceStyle}>
          <FirmwareBaseListView api={api}/>
        </Space>
        <Space style={{...spaceCarViewStyle, display: "inline-grid"}}>
          <JsonSchemaListView api={api}/>
          <GlobalLatestFirmwareView api={api}/>
        </Space>
      </Content>
    </Layout>
  )
}

export default FirmwareManagerView;
